// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14kLI","content":"styles_content__21OAC"};